<qbit-dialog-header title="{{title | translate}}" (click)="close()"></qbit-dialog-header>

<div class="bootstrap-wrapper">
    <div class="padd-20" style="max-height: 400px;overflow-y: auto;">
        <pre><code>{{data.json|json}}</code></pre>
    </div>
</div>